import React from "react"
import { makeStyles, Theme, Box, BoxProps } from "@material-ui/core"
import { calculateCompletionScore } from "./completionHelpers"
import { SchemaField } from "../featuer-layer-settings/schema"
import equal from "fast-deep-equal"

/** CompletionIndicator component props */
interface CompletionIndicatorProps extends BoxProps {
  fields: SchemaField[] | undefined
  attributes: Record<string, any>
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme, { completionScore: number | undefined }>(
  theme => ({
    trafficLight: {
      backgroundColor: ({ completionScore }) => {
        const palette = theme.palette.type === "dark" ? "base" : "pop"
        if (completionScore === undefined)
          // @ts-ignore
          return theme.palette[palette].purple
        if (completionScore > 0.5)
          // @ts-ignore
          return theme.palette[palette].green
        else if (completionScore > 0)
          // @ts-ignore
          return theme.palette[palette].orange
        // @ts-ignore
        else return theme.palette[palette].magenta
      },
    },
  })
)

export const CompletionIndicator = React.memo(
  ({ fields, attributes, ...props }: CompletionIndicatorProps) => {
    /** Calculate the completion score of the attributes */
    const completionScore =
      fields && calculateCompletionScore(fields, attributes)

    /** Get scoped CSS classes, which colours the box based on completion score */
    const classes = useStyles({ completionScore })

    return (
      <Box
        width={18}
        height={18}
        borderRadius={9}
        className={classes.trafficLight}
        {...props}
      />
    )
  },
  equal
)
